module.exports = __webpack_public_path__ + "static/img/1007_small.e57e492.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1007_small.png
// module id = 5p8j
// module chunks = 1